import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { useEffect } from 'react';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { aLink } from '@src/utils/common-util';
import { noop } from '@src/utils/common-util';

let _this = null;
let swiperThis = null;
class MoreMechaStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isActive = false;

  //机甲主体
  @observable mechaStore;

  @observable clickCback = noop;

  //当前的机甲列表角标
  @observable current_mecha_index = 0;

  moreMechaSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 1,
      observe: true,
      observeParents: true,
      on: {
        init: function () {
          swiperThis = this;
          let swiperItem = document.querySelectorAll('.swiperItem');
          swiperItem.forEach(item => {
            item.addEventListener('click', function () {
              let mechaid = this.getAttribute('mechaid');
              _this.onMechaPaginationClick(mechaid);
            });
          });
        }
      }
    }
  });

  // 其他机甲
  @observable more_mecha_list;

  /**
   * 页面跳转
   */
  jumpPage(url, params = null, newStatus = false) {
    let fullPath = window.location.origin + window.location.pathname;
    let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
    // 如果路径末尾没有斜杠，则添加斜杠（可选）
    if (!urlWithoutFileName.endsWith('/')) {
      urlWithoutFileName += '/';
    }
    let nextUrl = urlWithoutFileName + url;
    if (params) {
      nextUrl += `${params}`;
    }

    if (newStatus) {
      aLink(nextUrl);
    } else {
      window.location.href = nextUrl;
    }
  }

  onMechaPaginationClick = mecha_id => {
    // IS_DEV_ENV  DEPLOY_ENV
    if (!IS_DEV_ENV) {
      const url = 'mecha.html';
      this.jumpPage(url, `#/?mecha_id=${mecha_id}`);
    } else {
      this.mechaStore.redirect(`/mecha?mecha_id=${mecha_id}`);
    }
    this.clickCback();
  };

  use() {
    _this = this;
    useEffect(() => { }, []);
    useMount(async () => { });
  }
}

export default MoreMechaStore;
